import React from 'react';
import landing from "../Images/Landing.jpg";
import home from "../Images/About.jpg";
import project from "../Images/Previous.jpg";
import {Link} from 'react-router-dom';
import Footer from "../Components/Footer";

const Home = ({products}) => {
    const inViewport = (elements, observer) =>{
        elements.forEach(element => {
        })
      }
      const Obs = new IntersectionObserver(inViewport);
      const obsOptions = {threshold:0.05};
    
      const ELs_inViewport = document.querySelectorAll('#product');
      ELs_inViewport.forEach(EL =>{
          Obs.observe(EL, obsOptions)
      })


    return(
    <div>
        <div className="landing">
          <img src={landing} className="image" alt=""/>
        </div>
        <section className="services">
            <h1>
                Our Products
            </h1>
            <div className="products">
                {products}
            </div>
        </section>
        <section className="section odd">
            <div className="content">
                <h1 className="header">
                    About Us
                </h1>
                <p className="text">
                    We aim to provide the highest quality end-to-end fenestration solutions for your business.  From planning to installation, we work with you every step of the way. We'll ensure that all your needs are met and that your experience exceeds all expectations.
                </p>
                <Link className="learn" to="/About">
                    Learn More {`->`}
                </Link>
            </div>
            <img src={home} className="sub-image" alt=""/>
        </section>
        <section className="section even">
            <img src={project} className="sub-image" alt=""/>
            <div className="content">
                <h1 className="header">
                    Previous Work
                </h1>
                <p className="text">
                    We've already helped several clients in our area with their fenestration needs. See how our detailed work has transformed their business for the better!
                </p>
                <Link className="learn" to="/Gallery">
                    See More {`->`}
                </Link>
            </div>
        </section>
        <Footer/>
    </div>
    )
}

export default Home;